/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { sort, descend } from 'ramda';
import PageContainer from 'components/PageContainer';
import styles from './styles';
import AccountSelectionWidget, {
  displayedCreditLimit,
} from './AccountSelectionWidget';

import { Tenant } from 'state/tenant';
import { InstantCredit } from 'state/instantCredit';
import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';

interface PropTypes {
  tenant: Tenant;
  accounts: InstantCredit[];
  onWidgetClick: (account: InstantCredit) => void;
}

const AccountSelectionView: React.FC<PropTypes> = ({
  tenant,
  accounts,
  onWidgetClick,
}) => {
  const tMd = useMarkdownTranslate();

  // TODO: Confirm that names are the same on all accounts, so
  // we can just use the first one.
  const { firstName } = accounts[0];

  const sortedAccounts = sort(
    descend(account => displayedCreditLimit(account, tenant) || 0),
    accounts,
  );

  return (
    <PageContainer maxWidth="sm">
      <div css={styles.titleText}>
        {tMd('accountSelection.title', { firstName })}
      </div>

      {sortedAccounts.map((account, index) => {
        return (
          <AccountSelectionWidget
            key={index}
            account={account}
            tenant={tenant}
            onWidgetClick={onWidgetClick}
          />
        );
      })}
    </PageContainer>
  );
};

export default AccountSelectionView;
